import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 180px;
    position: relative;
}
`;

export const Content = styled.div`
display: flex;
width: 100%;
height: auto;
margin-top: 20px;
position: relative;
}
`;

export const Text = styled.span`
    color: #5f5f65;
    margin-top: 15px;
    font-size: 25px;
    width: calc(100% - 110px);;
    margin-left: 10px;
    text-align: center;
}
`;

export const SubText = styled.span`
    color: #5f5f65;
    font-size: 15px;
    margin-left: 10px;
    margin-bottom: 5px;
}
`;

export const Extra = styled.div`
    position: absolute;
    bottom: 7px;
    margin-top: 1px;
`;
